import { ICommonOption } from "./ICommonOption";
import { IExtra } from "./IExtra";
import { IInstruction } from "./IInstruction";
import { IOption } from "./IOption";
import { defaultProduct, IProduct } from "./IProduct";
import { IVariation } from "./IVariation";

export interface IReceiptRow {
  id: number;
  uuid: string;
  product: IProduct;
  description: string[];
  variations: IVariation[];
  extras: IExtra[];
  commonOptions: ICommonOption[];
  notes: string;
  instructions: IInstruction[];
  price: number;
  qty: number;
  isDiscount: boolean;
  options: IOption[];
}

export const defaultReceiptRow: IReceiptRow = {
  id: 0,
  product: defaultProduct,
  description: [],
  variations: [],
  extras: [],
  commonOptions: [],
  notes: "",
  instructions: [],
  price: 0,
  qty: 0,
  isDiscount: false,
  options: [],
  uuid: "",
};
